import React from 'react'

function Congrats(props) {
  return(
    <div className="container">
      <p>Ваша Заявка принята и поступила в обработку.</p>
      <p>В течении ближайщих 2 рабочих дней менеджер отправит Вам пакет документов по указанному Вами адресу электронной почты.</p>
      <p>Спасибо, что выбрали нас.</p>
      <p>С уважением, служба поддержки Клиентов НПК "СВИМУЧ" (ЗАО)</p>
      <br />
      <h4 className="title is-4" style={{color: 'red'}}>Внимание</h4>
      <p>Если в течении 2-х рабочих дней вы не получите от нас пакет документов, пожалуйста, перезвоните по телефону 8-929-4-295-295 для уточнения деталей.</p>
    </div>
  )
}

export default Congrats


// WEBPACK FOOTER //
// ./src/components/Congrats.js